
// @ts-nocheck
import locale_nl_46json_d1577f5f from "#nuxt-i18n/d1577f5f";
import locale_nl_45BE_46json_78fa1f33 from "#nuxt-i18n/78fa1f33";
import locale_fr_46json_3676bfd9 from "#nuxt-i18n/3676bfd9";

export const localeCodes =  [
  "nl-NL",
  "nl",
  "fr"
]

export const localeLoaders = {
  "nl-NL": [
    {
      key: "locale_nl_46json_d1577f5f",
      load: () => Promise.resolve(locale_nl_46json_d1577f5f),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_45BE_46json_78fa1f33",
      load: () => Promise.resolve(locale_nl_45BE_46json_78fa1f33),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_3676bfd9",
      load: () => Promise.resolve(locale_fr_46json_3676bfd9),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/ee4e6a16" /* webpackChunkName: "config_i18n_46config_46ts_ee4e6a16" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "nl-NL",
      name: "NL",
      language: "nl-NL",
      files: [
        {
          path: "/app/i18n/locales/nl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      name: "BE",
      language: "nl-BE",
      files: [
        {
          path: "/app/i18n/locales/nl-BE.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      name: "FR",
      language: "fr-FR",
      files: [
        {
          path: "/app/i18n/locales/fr.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "nl-NL",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "nl-NL",
    name: "NL",
    language: "nl-NL",
    files: [
      {
        path: "/app/i18n/locales/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    name: "BE",
    language: "nl-BE",
    files: [
      {
        path: "/app/i18n/locales/nl-BE.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "FR",
    language: "fr-FR",
    files: [
      {
        path: "/app/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/